<div class="contract-view" *ngIf="contractData">
  <div class="contract-hero">
    <div class="contract-hero__client">
      <p class="contract-hero__label">Cliente</p>
      <h2 class="contract-hero__name">{{ contractData.Client || '-' }}</h2>
      <p class="contract-hero__doc">CPF/CNPJ {{ contractData.ClientDocument || '-' }}</p>
    </div>

    <div class="contract-hero__stats">
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Valor do Financiamento</p>
        <p class="contract-hero__stat-value">{{ (contractData.Amount | currency: 'BRL') || '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Alíquota</p>
        <p class="contract-hero__stat-value">{{ (contractData.Fee !== null && contractData.Fee !== undefined) ? (contractData.Fee | number: '1.0-2') + '%' : '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Produto</p>
        <p class="contract-hero__stat-value">{{ contractData.Product || '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Banco</p>
        <p class="contract-hero__stat-value">{{ (contractData.FinancialInstitution | titlecase) || '-' }}</p>
      </div>
    </div>
  </div>

  <div class="contract-card timeline-card" *ngIf="isLoading">
    <app-skeleton variant="card" [lines]="2" *ngFor="let item of [1, 2, 3]"></app-skeleton>
  </div>

  <div class="ui-empty-state" *ngIf="!isLoading && combinedLogs?.length === 0">
    <span class="ui-empty-state__message">Não há Logs</span>
  </div>

  <div class="contract-card timeline-card" *ngIf="!isLoading && combinedLogs?.length">
    <div class="timeline">
      <div class="timeline-item" *ngFor="let log of combinedLogs">
        <div class="timeline-item__date">
          <p class="timeline-item__date-day">{{ logDate(log) }}</p>
          <p class="timeline-item__date-time">{{ logTime(log) }}</p>
        </div>

        <div class="timeline-item__marker">
          <span class="timeline-item__dot" [ngClass]="'timeline-item__dot--' + logTone(log)"></span>
        </div>

        <div class="timeline-item__content">
          <p class="timeline-item__title">{{ logTitle(log) }}</p>
          <p class="timeline-item__desc">{{ logDescription(log) }}</p>

          <div class="timeline-item__tags" *ngIf="!isPartnerChangeLog(log)">
            <span class="timeline-item__tag" *ngIf="log.BatchNumber"><b>Lote</b> {{ log.BatchNumber }}</span>
            <span class="timeline-item__tag" *ngIf="log.ParentBatchNumber"><b>Lote pai</b> {{ log.ParentBatchNumber }}</span>
            <span class="timeline-item__tag"><b>Usuário</b> {{ log.Username || '-' }}</span>
          </div>

          <div class="timeline-item__tags" *ngIf="isPartnerChangeLog(log)">
            <span class="timeline-item__tag"><b>Usuário</b> {{ log.ChangeUserName || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
